/* eslint-disable no-underscore-dangle */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { assignFormDesignToCSSVars, whenSideBySide } from '../fields-customise.style';
import { RankingItem, RankingItemWrapper, Input } from './ranking.styled';
import { FormContext } from '../../../shared/contexts/form-context';
import { ctrlDefaults } from '../../../../shared/form-lib';
import { ControlPropType } from '../../ctrl_proptype';
import { selectCtrlIdLabelMap } from '../../selectors';
import DragContext from './drag_ranking';
import {
  ValidationWarning,
  MainfieldWrapper,
  SubtextWrapper,
  FieldWrapper,
  LabelWrapper,
  Field,
} from '../../common-field-styles';

const Ranking = ({ ctrl, formDesign }) => {
  const { inCustomise, inBuilder } = useContext(FormContext);
  const ctrlIdLabelMap = useSelector(selectCtrlIdLabelMap);
  const fieldLabel = ctrlIdLabelMap?.[ctrl.internal_id];

  return (
    <MainfieldWrapper style={assignFormDesignToCSSVars(inBuilder, formDesign)}>
      <FieldWrapper>
        {ctrl._validationError && (
          <ValidationWarning className="ui bottom pointing basic label red">{ctrl._validationError}</ValidationWarning>
        )}

        <Field className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
          <LabelWrapper
            pad="0 0 0.625rem"
            notInBuilder={!inBuilder}
            required={ctrl.props.required}
            className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
            <label dangerouslySetInnerHTML={{ __html: fieldLabel || ctrlDefaults()[ctrl.type] }} />
          </LabelWrapper>

          {!inBuilder && !inCustomise && <DragContext ctrl={ctrl} formDesign={formDesign} />}

          {(inBuilder || inCustomise) && (
            <RankingItemWrapper
              type={`ranking-${ctrl.internal_id}`}
              className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
              {ctrl.props.options.map((elem, index) => {
                const id = `${elem}-${index}`;
                return (
                  <div key={id}>
                    <RankingItem notInBuilder={!inBuilder}>
                      <span>
                        <img src="https://storage.googleapis.com/fplsblog/drag-icon.svg" alt="drag handle" />
                      </span>
                      <span>{index + 1}.</span>
                      {elem}
                    </RankingItem>
                  </div>
                );
              })}

              {ctrl.props.other.enabled && (
                <RankingItem notInBuilder={!inBuilder}>
                  <span>
                    <img src="https://storage.googleapis.com/fplsblog/drag-icon.svg" alt="drag handle" />
                  </span>
                  <span>{ctrl.props.options.length + 1}.</span>
                  <Input
                    notInBuilder={!inBuilder}
                    placeholder="Click to add your option"
                    disabled={ctrl.props.readonly || inCustomise || inBuilder}
                  />
                </RankingItem>
              )}

              <SubtextWrapper id="descriptive text">{ctrl.props.subtext}</SubtextWrapper>
            </RankingItemWrapper>
          )}
        </Field>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

Ranking.defaultProps = {
  formDesign: null,
};

Ranking.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};
export default Ranking;
